//include 4 
jQuery(function(){
    // add-class-overlaykarte    
    $("body").on("click ",".open-in-modal",function(e){
        var element = $(e.target).closest(".open-in-modal");
        var href = element.attr("href");
        var classesToAdd = [];
        var allClasses = element.attr('class').split(/\s+/);
        $.each(allClasses, function(index, item) {
            if(item.startsWith("add-class-")){
                classesToAdd.push(item.replace("add-class-",""));
            }
        });

        var forceModal = element.hasClass("force-modal");
        
        if(!!href){

            if (window.pixelpoint.isMobile.any() && !forceModal) {
                element.attr("target","_blank");
            }
            else{
                e.preventDefault();
                var instance = lity(href);
                if(!!classesToAdd){
                    for(var i = 0;i < classesToAdd.length;i++){
                        instance.element().addClass(classesToAdd[i]);
                    }
                }
                //instance.element().addClass('overlaykarte');
                element.data("modal-instance",instance);
            }
        }
    });
});